import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';

import * as styles from './styles.css';
import { Typography } from '../../../Typography';

export interface IApplyHeaderProps {
  subtitle?: string;
  title?: string;
}

export const ApplyHeader: React.FC<IApplyHeaderProps> = ({ subtitle = '', title = '' }) => {
  const deviceType = useDeviceType();

  return (
    <div className={styles['wrapper']}>
      {subtitle && <span className={styles['subtitle']}>{subtitle}</span>}
      {title && <Typography.Title level={deviceType === 'desktop' ? 5 : 6}>{title}</Typography.Title>}
    </div>
  );
};
